import './plug.scss'
import { SmallScreenPlugIcon } from '@/shared/assets'

export const Plug = () => (
    <div className="plug">
        <div className="plug__content">
            <img src={SmallScreenPlugIcon} alt="Plug Icon" />
        </div>
    </div>
)
